import { Space as AntSpace } from 'antd';
import React, { FC } from 'react';
import { CopyToClipboard } from 'components/atoms/copy-to-clipboard/copy-to-clipboard';
import { useTranslation } from 'hooks/use-translation';
import { SettingsLabel } from '../styles';
import { Description, LinkText, Space } from './custom-domain.styles';

const httpRegEx = /^(https?:\/\/)/gi;

export const Verified: FC<{ url: string }> = ({ url }) => {
  const title = useTranslation('settings.custom_domain.verified.title');
  const description = useTranslation(
    'settings.custom_domain.verified.description',
  );

  const hyperLink = httpRegEx.test(url) ? url : `https://${url}`;

  return (
    <Space size="small">
      <SettingsLabel>{title}</SettingsLabel>
      <AntSpace size={0} align="center">
        <LinkText href={hyperLink} target="_blank">
          {hyperLink}
        </LinkText>
        <CopyToClipboard textToCopy={hyperLink} />
      </AntSpace>
      <Description color="success">{description}</Description>
    </Space>
  );
};
